export default __webpack_public_path__ + "static/media/box.8447a228.png";